import { lazy } from 'react';
import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';
import { ANALYTICS_RULES, access, param } from '../../access';

const FormulaConfiguration = withLazyLoading(() => import('../../pages/FormulaConfiguration'));
const FormulaCreation = lazy(() =>
  import('../../pages/formulas').then(module => ({ default: module.FormulaCreation }))
);
const DynamicFormulaCreation = lazy(() =>
  import('../../pages/formulas').then(module => ({ default: module.DynamicFormulaCreation }))
);
const FormulaListing = lazy(() =>
  import('../../pages/formulas').then(module => ({ default: module.FormulaListing }))
);

const formulaRoutes = [
  {
    path: '/formulaConfiguration/:id',
    element: <FormulaConfiguration />,
    handle: { ...createCrumbHandle('Formula Configuration'), ...access(ANALYTICS_RULES.formulas, param('id')) },
  },
  {
    path: '/formula-list',
    handle: createCrumbHandle('Formulas'),
    children: [
      {
        index: true,
        element: withPostHogTracker(<FormulaListing />),
        handle: access(ANALYTICS_RULES.formulas),
      },
      {
        path: 'formula-creation/:formulaId?',
        element: withPostHogTracker(<FormulaCreation />),
        handle: { ...createCrumbHandle('Create Formula'), ...access(ANALYTICS_RULES.formulas) },
      },
      {
        path: 'dynamic-formula-creation/:dynamicFormulaId?',
        element: <DynamicFormulaCreation />,
        handle: { ...createCrumbHandle('Create Dynamic Formula'), ...access(ANALYTICS_RULES.formulas) },
      },
    ]
  },
];

export default formulaRoutes;
